import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const addFavoriteForm = async (formId: string): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation addFavoriteForm($formId: String!) {
        addFavoriteForm(formId: $formId)
      }
    `),
    variables: {
      formId,
    },
  });

  return response.data?.addFavoriteForm ?? false;
};
